export const metaAttrList = [
  'name="description"',
  'name="twitter:card"',
  'name="thumbnail"',
  'property="og:url"',
  'property="og:type"',
  'property="og:title"',
  'property="og:description"',
  'property="og:image"',
  'property="fb:app_id"',
];
